import { render, staticRenderFns } from "./Sustainable.vue?vue&type=template&id=f1f61f10&scoped=true&"
import script from "./Sustainable.vue?vue&type=script&lang=js&"
export * from "./Sustainable.vue?vue&type=script&lang=js&"
import style0 from "./Sustainable.vue?vue&type=style&index=0&id=f1f61f10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f61f10",
  null
  
)

export default component.exports